import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { hasExtractRefreshPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IDatasourceActions } from '../../datasource/ServerApi/types/IDatasourceActions';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { IWorkbookActions } from '../../workbook/ServerApi/types/IWorkbookActions';
import { deleteExtractRefresh } from '../actions/DeleteExtractRefreshAction';

export const DeleteExtractRefreshEntityAction:
    IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksDelete,
  translateName: Messages.delete_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: deleteExtractRefresh
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractRefreshPermission(state, spaceItem, availableActions);
}
